import moment from 'moment'

export const isToday = (time) => {
    const now = moment();
    const inputTime = moment(time);
    return now.isSame(inputTime, "day");
}

export const isValidPhoneNumber = (phoneNumber) => {
    // 正则表达式：匹配11位手机号码
    const regex = /^1[3-9]\d{9}$/;
    return regex.test(phoneNumber);
}

export const getChannel = (domain) => {
    const regex = /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i;
    let c = 0;
    if (regex.test(domain)) {
        let hostname = domain.split('.');
        if (hostname.length > 2) {
            if (hostname.length > 3) {
                c = parseInt(hostname[hostname.length - 3])
            } else {
                c = parseInt(hostname[0])
            }
        }
        if (isNaN(c)) {
            c = 0
        }
    }
    return c;
}

export const countDown = (t) => {
    let targetTime = moment(t)
    let now = moment()

    let duration = moment.duration(targetTime.diff(now))

    let days = duration.days()
    let hours = duration.hours()
    let minutes = duration.minutes()
    let seconds = duration.seconds()

    let parts = []

    if (days > 0) parts.push(`${days}天`)
    if (days > 0 || hours > 0) parts.push(`${hours}时`)
    if (days > 0 || hours > 0 || minutes > 0) parts.push(`${minutes}分`)
    parts.push(`${seconds}秒`)

    return parts.join('')
}

export const updateUrlParams = (url, params = {}) => {
    if (url != "") {
        const urlObj = new URL(url);
        for (const [key, value] of Object.entries(params)) {
            urlObj.searchParams.set(key, value); // 添加或替换参数
        }
        return urlObj.toString();
    }
}

export const getDomainSetting = () => {
    var fullDomain = window.location.hostname;
    if (fullDomain.indexOf("6wv.com") > -1) {
        return {channelId:"12",kfWx:"6wvwx",site:"6wv",doamin:"6wv",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("996hf.com")  > -1 ) {
        return {channelId:"12",kfWx:"996hfwx",site:"996hf",doamin:"996hf",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("4xf.com")  > -1) {
        return {channelId:"28",kfWx:"4xfwx",site:"4xf",doamin:"4xf",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("77k.com")  > -1) {
        return {channelId:"17",kfWx:"77kwx",site:"77k",doamin:"77k",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("1aa.com")  > -1) {
        return {channelId:"18",kfWx:"1aawx",site:"1aa",doamin:"1aa",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("8gn.com")  > -1) {
        return {channelId:"30",kfWx:"8gnwx",site:"8gn",doamin:"8gn",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("2uh.com")  > -1) {
        return {channelId:"4",kfWx:"2uhhezi",site:"2uh",doamin:"2uh",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("pk53.com")  > -1) {
        return {channelId:"30",kfWx:"8gnwx",site:"pk53",doamin:"pk53",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("45hao.com")  > -1) {
        return {channelId:"30",kfWx:"8gnwx",site:"pk53",doamin:"45hao",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("45hao.com")  > -1) {
        return {channelId:"30",kfWx:"8gnwx",site:"pk53",doamin:"45hao",downloadHref:"",beian:""};
    }else if (fullDomain.indexOf("localhost")  > -1) {
        return {channelId:"4",kfWx:"2uhhezi",site:"2uh",doamin:"2uh",downloadHref:""};
    }else if (fullDomain.indexOf("182.106.136.95")  > -1) {
        return {channelId:"4",kfWx:"2uhhezi",site:"2uh",doamin:"2uh",downloadHref:""};
    }else{
        return {channelId:"17",kfWx:"77kwx",site:"77k",doamin:"77k",downloadHref:""};
    }
}
